// Smyle-branded CSAT faces — the blue mascot (matching the widget launcher bubble,
// see sdk/bubbleHelpers.js) expressed across the 5-point satisfaction scale. The
// gradient + white features stay constant; only the mouth changes (deep frown ->
// flat -> grin), and "Excellent" reuses the signature sparkle-eye mascot face.
//
// Single source of truth: the dashboard settings tile, the hosted survey page and
// the chat widget's survey card all render these SVG strings; the email surface
// uses PNG exports of the same faces (gs://maestro-email-assets/csat/face-<value>.png).

const gradient = id =>
  `<defs><linearGradient id="${id}" x1="3.5" y1="3.5" x2="20.5" y2="20.5" gradientUnits="userSpaceOnUse">` +
  `<stop offset="0" stop-color="#5BB4FF"/><stop offset="1" stop-color="#1E6BF0"/></linearGradient></defs>`;

const EYES =
  '<circle cx="8.3" cy="9.3" r="1.55" fill="#fff"/><circle cx="15.7" cy="9.3" r="1.55" fill="#fff"/>';

const mouth = d =>
  `<path d="${d}" stroke="#fff" stroke-width="1.7" stroke-linecap="round" fill="none"/>`;

// Sparkle eye + dot eye + toothy grin, traced from the brand mascot PNG.
const MASCOT =
  '<path fill="#fff" fill-rule="evenodd" d="M8 6.3Q8.7 8.26 10.55 9Q8.7 9.74 8 11.7Q7.3 9.74 5.45 9Q7.3 8.26 8 6.3ZM14.3 9a1.7 1.7 0 1 0 3.4 0a1.7 1.7 0 1 0 -3.4 0ZM6.56 14.06C8.91 15.94 14.81 15.94 16.78 13.69C16.12 15 15.19 16.41 14.25 16.69C13.12 17.25 10.31 17.25 9.19 16.69C8.44 16.31 7.5 15.19 6.56 14.06ZM9.09 15.47L9.47 15.47L9.38 16.59L9.19 16.59ZM11.7 15.66L12.11 15.66L12.01 17.06L11.8 17.06ZM14.44 15.47L14.81 15.47L14.72 16.59L14.53 16.59Z"/>';

const face = (id, inner) =>
  `<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="none">${gradient(id)}` +
  `<circle cx="12" cy="12" r="12" fill="url(#${id})"/>${inner}</svg>`;

export const SMYLE_CSAT_FACES = [
  {
    value: 1,
    key: 'poor',
    svg: face('smyle-csat-1', EYES + mouth('M7.6 16.4 Q12 12.6 16.4 16.4')),
  },
  {
    value: 2,
    key: 'fair',
    svg: face('smyle-csat-2', EYES + mouth('M8 15.8 Q12 14.4 16 15.8')),
  },
  {
    value: 3,
    key: 'average',
    svg: face('smyle-csat-3', EYES + mouth('M8.4 15.1 L15.6 15.1')),
  },
  {
    value: 4,
    key: 'good',
    svg: face('smyle-csat-4', EYES + mouth('M8 14.5 Q12 16.9 16 14.5')),
  },
  { value: 5, key: 'excellent', svg: face('smyle-csat-5', MASCOT) },
];
